// Centralized constants to avoid duplication and improve maintainability

export const CHECKOUT_URL =
  'https://pay.hotmart.com/P105640736H?off=lobf5sth&checkoutMode=10&bid=1779746895468'

export const META_PIXEL_ID = '26913593174942930'

export const MAIN_IMG =
  'https://cdn.magicpatterns.com/uploads/pb2oZ2RUzyQBkYMGwuGsQQ/Tomo_1.png'

export const BONUS_IMGS = [
  'https://cdn.magicpatterns.com/uploads/1v1tHcyCreatuCmkt28rVw/bono_1.png',
  'https://cdn.magicpatterns.com/uploads/vGHom5ujRe81NveL3u3iN1/bono_2.png',
  'https://cdn.magicpatterns.com/uploads/7PtXNs7FzsdeptdeETMC52/bono_3.png',
  'https://cdn.magicpatterns.com/uploads/brVZx9HsAREbCYwF2bHr3E/bono_4.png',
] as const
